import { useEffect } from 'react'
import { IconButton, Snackbar, SnackbarContent, SnackbarContentProps } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { router } from '@inertiajs/react'
import { FlashNotification, useFlashNotificationStore } from '@/lib/flashNotifications'

export const FlashNotifications = () => {
  const notification = useFlashNotificationStore(state => state.notifications[0])

  useEffect(() => {
    return router.on('success', event => {
      useFlashNotificationStore.getState().addNotificationsFromPage(event.detail.page as any)
    })
  }, [])

  if (!notification) {
    return null
  }

  const Notification = FLASH_NOTIFICATIONS_BY_TYPE[notification.type] || BaseFlashNotification
  return <Notification key={notification.id} notification={notification} />
}

type FlashNotificationProps = { notification: FlashNotification } & SnackbarContentProps

const BaseFlashNotification = ({ notification, ...props }: FlashNotificationProps) => {
  const { id, message } = notification

  return (
    <Snackbar
      open
      autoHideDuration={6000}
      onClose={() => useFlashNotificationStore.getState().removeNotification(id)}
      slotProps={{
        clickAwayListener: {
          onClickAway: (event: any) => {
            event.defaultMuiPrevented = true
          },
        },
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <SnackbarContent
        id={id}
        message={message}
        action={
          <IconButton
            color='inherit'
            size='small'
            onClick={() => useFlashNotificationStore.getState().removeNotification(id)}
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        }
        {...props}
      />
    </Snackbar>
  )
}

const NoticeFlashNotification = (props: FlashNotificationProps) => (
  <BaseFlashNotification {...props} sx={{ bgcolor: 'success.main', color: 'common.white' }} />
)

const AlertFlashNotification = (props: FlashNotificationProps) => (
  <BaseFlashNotification {...props} sx={{ bgcolor: 'warning.dark', color: 'common.white' }} />
)

const ErrorFlashNotification = (props: FlashNotificationProps) => (
  <BaseFlashNotification {...props} sx={{ bgcolor: 'error.main', color: 'common.white' }} />
)

const FLASH_NOTIFICATIONS_BY_TYPE = {
  notice: NoticeFlashNotification,
  alert: AlertFlashNotification,
  error: ErrorFlashNotification,
} as const satisfies Record<FlashNotification['type'], React.ComponentType<FlashNotificationProps>>
